import { useLogin } from '@/components/Login'
import { useGoogle } from './useGoogle'
import storage from '@/utils/storage'
import { useUserStore } from '@/pinia/user'

const VIEW_DETAIL_COUNT = 'bestdealer-view-detail-count'

export const useGoogleOneTap = async () => {
  const route = useRoute()
  const { inited, requestOneTap, closeOneTap } = useGoogle()
  const { login } = useLogin()
  const user = useUserStore()
  let open = false

  watch(() => [route.name, inited.value], () => {
    check()
  })

  watch(() => user.isLogged, (logged) => {
    if (open && logged) {
      closeOneTap()
      /**
       * 登录完成后清除
       */
      storage.remove(VIEW_DETAIL_COUNT)
    }
  })

  const check = () => {
    if (!inited.value || user.isLogged) return
    let count = storage.get(VIEW_DETAIL_COUNT) ?? 0
    if (count > 0) {
      createOneTap()
    } else if (route.name === 'offer') {
      storage.set(VIEW_DETAIL_COUNT, ++count)
    }
  }

  const createOneTap = async () => {
    open = true
    const accessToken = await requestOneTap()
    await login({
      loginType: 'google_id_token',
      accessToken
    })
  }
}
